module.exports = __webpack_public_path__ + "static/img/banner2.8678b22.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/banner2.jpg
// module id = v9KI
// module chunks = 12